module.exports = require('./helpers/bundle-url').getBundleURL('3Bta7') + "logo.c51670a8.svg";